module.exports = __webpack_public_path__ + "static/assets/7d3dd7098c7f0f16ebd370cfeb1161e9.png";